export const AccountActionTypes = {
  SET_ACTIVE_ADDRESS: "SET_ACTIVE_ADDRESS",
  GET_PROFILE: "GET_PROFILE",
  ACCOUNT_LOADING: "ACCOUNT_LOADING",
  ACCOUNT_ERROR: "ACCOUNT_ERROR",
  SET_PROFILE_ATTRIBUTE: "SET_PROFILE_ATTRIBUTE",
  // Move to new set for TNX
  SET_TNX_STATUS: "SET_TNX_STATUS",
  // COLLECTION
  SET_ADD_COLLECTION_TNX_STATUS: "SET_ADD_COLLECTION_TNX_STATUS",
  CLEAR_ADD_COLLECTION_TNX_STATUS: "CLEAR_ADD_COLLECTION_TNX_STATUS",
  // NFT
  SET_ADD_NFT_TNX_STATUS: "SET_ADD_NFT_TNX_STATUS",
  CLEAR_ADD_NFT_TNX_STATUS: "CLEAR_ADD_NFT_TNX_STATUS",
  // Move to new set for TNX
  //EVENTS
  SET_EVENTS: "SET_EVENTS",
  SET_BULK_TX_STATUS: "SET_BULK_TX_STATUS",
};
